import { render } from "./EditDocumentCetateniDetail.vue?vue&type=template&id=313daa92&scoped=true&ts=true"
import script from "./EditDocumentCetateniDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditDocumentCetateniDetail.ts?vue&type=script&lang=ts&external"

import "./EditDocumentCetateniDetail.vue?vue&type=style&index=0&id=313daa92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313daa92"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QBtn,QTooltip,QSpinner,QMenu,QDialog,QCard,QLinearProgress,QCardSection,QInput,QField});
